export const showFirstValidationErrorFromAPI = (errorsArray) => {
  return errorsArray?.[Object?.keys(errorsArray)?.[0]]?.[0];
};
